<script>
import Loader from "@/components/widgets/loader";
import Swal from "sweetalert2";
import Layout from '../../../layouts/main'
import PageHeader from '@/components/page-header'

import appConfig from "@/app.config";

import {getScheduler, getRiskScheduler, updateScheduler} from '@/api/user'

/**
 * Products-order component
 */
export default {
   page: {
    title: "Orders",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader },
  props: {
    updating: {
      type: Boolean,
    },
  },
  data() {
    return {
      title: '任务监控',
      scheduler_list: [],
      risk_scheduler_list: [],
      pwd: '',
      strategy: {},
      loading: false,
      showSetting: false,
      isauthenticated: true,
      current_data: {}
    }
  },
  methods: {
    getSchedulerList() {
      getScheduler().then((res) =>{
        this.scheduler_list = res
      }).catch((error) => {
        console.log("error")
        console.log(error)
      })
    },
    getRiskSchedulerList() {
      getRiskScheduler().then((res) =>{
        this.risk_scheduler_list = res
      }).catch((error) => {
        console.log("error")
        console.log(error)
      })
    },
    checkCurrentSetting(current_data) {
      this.current_data = current_data
      this.showSetting = true
    },
    updateSetting(job_id, setting, pwd){
        let data = {
            "job_id": job_id,
            "passwd": pwd,
            "setting": setting
        }
        let promise = updateScheduler(data); return promise.then(res => {
            if (res["message"] == "请求成功"){
                this.pwd = ""
                Swal.fire({
                title: "配置更新成功！",
                text: res["message"],
                icon: "success",
                // background: "#222736"
                })
                window.location.reload()
            } else{
                Swal.fire({
                title: "配置更新失败！",
                text: res["message"],
                icon: "error",
                // background: "#222736"
                })
                this.showSetting = false
                }
        }).catch(error => {
            console.log(error)
        })
    },
  },
  mounted() {
    console.log('scheduler management!-----------')
    this.getRiskSchedulerList()
    this.getSchedulerList()
  },
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
    />


    <div v="risk_scheduler_list">
      <div v-if="isauthenticated">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <!-- Table data -->
                <!-- <T :transactions="strategy_list" /> -->
                <Loader :loading="updating">
                  <div class="table-responsive mb-0">
                    <table class="table table-centered table-nowrap">
                      <thead class="thead-light">
                        <tr>
                          <th>Name</th>
                          <!-- <th>type</th> -->
                          <!-- <th>策略设置</th> -->
                          <th>Interval</th>
                          <th>Last_run_time</th>
                          <th>Count</th>
                          <th>Status</th>
                          <th>Setting</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="job in risk_scheduler_list"
                          :key="job.name"
                        >
                          <td>
                            <a
                              href="javascript: void(0);"
                              class="text-body font-weight-bold"
                            >{{ job.name }}</a>
                          </td>
                          <td>{{ job.interval }}</td>
                          <td>{{ job.last_run_time }}</td>
                          <td>{{ job.count }}</td>
                          <td>
                            <span
                              class="badge badge-pill badge-soft-success font-size-12"
                              :class="{
                                'badge-soft-danger': `${job.status}` === 'error',
                                // 'badge-soft-warning': `${job.status}` === 'normal',
                              }"
                            >{{ job.status }}</span>
                          </td>
                          <td>
                              <button  


                              type="button"
                              class="btn btn-info btn-sm btn-rounded"
                              @click="checkCurrentSetting(job)"
                              >
                              查看
                              </button>

                              <b-modal
                              v-model="showSetting"
                              title="查看参数配置"
                              centered
                              >
                              <div>
                                  <table class="table table-centered table-nowrap">
                                  <!-- <b-form-group
                                      id="example text"
                                      label-cols-lg="5"
                                      label="品种"
                                      label-for="text"
                                  >
                                  <b-form-input v-model="current_strat_symbol" />
                                  </b-form-group> -->
                                  <div v-for="(value,key,index) in current_data.setting" :key="index">
                                      <b-form-group
                                      id="example text"
                                      label-cols-lg="5"
                                      :label="key"
                                      label-for="text"
                                      >
                                      <b-form-input v-model="current_data.setting[key]"/>
                                      </b-form-group>
                                  </div>
                                  <b-form-group
                                    id="example text"
                                    label-cols-lg="5"
                                    label="密码"
                                    label-for="text"
                                  >
                                  <b-form-input type="password" v-model='pwd'/>
                                  </b-form-group>
                                  </table>
                              </div>
                              <template v-slot:modal-footer>
                                  <b-button
                                  variant="secondary"
                                  @click="updateSetting(current_data.id, current_data.setting, pwd)"
                                  >
                                  确认更新
                                  </b-button>
                              </template>
                              </b-modal>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- end table -->
                </Loader>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </div>
          <!-- end col -->
        </div>
      </div>
    </div>


    <div v="scheduler_list">
      <div v-if="isauthenticated">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <!-- Table data -->
                <!-- <T :transactions="strategy_list" /> -->
                <Loader :loading="updating">
                  <div class="table-responsive mb-0">
                    <table class="table table-centered table-nowrap">
                      <thead class="thead-light">
                        <tr>
                          <th>Name</th>
                          <!-- <th>type</th> -->
                          <!-- <th>策略设置</th> -->
                          <th>Interval</th>
                          <th>Last_run_time</th>
                          <th>Count</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="job in scheduler_list"
                          :key="job.name"
                        >
                          <td>
                            <a
                              href="javascript: void(0);"
                              class="text-body font-weight-bold"
                            >{{ job.name }}</a>
                          </td>
                          <td>{{ job.interval }}</td>
                          <td>{{ job.last_run_time }}</td>
                          <td>{{ job.count }}</td>
                          <td>
                            <span
                              class="badge badge-pill badge-soft-success font-size-12"
                              :class="{
                                'badge-soft-danger': `${job.status}` === 'error',
                                // 'badge-soft-warning': `${job.status}` === 'normal',
                              }"
                            >{{ job.status }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- end table -->
                </Loader>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </div>
          <!-- end col -->
        </div>
      </div>
    </div>
  </Layout>
</template>
